import $ from 'jquery';
// Set jQuery global
window.$ = window.jQuery = $;

// String.prototype.includes()
if (!String.prototype.includes) {
  Object.defineProperty(String.prototype, 'includes', {
    value: function(search, start) {
      if (typeof start !== 'number') {
        start = 0
      }

      if (start + search.length > this.length) {
        return false
      } else {
        return this.indexOf(search, start) !== -1
      }
    }
  })
}

var $filterItems = $('.filter-item'),
    filterItemslength = $filterItems.length;

if (filterItemslength > 0) {

  var $selectFilter = $('.custom-select.filter'),
      $inputFilter = $('input.filter-search'),
      $filterForm = $('form.form-filter'),
      $btnResetFilter = $('.btn-filter-reset'),
      $alertNoItems = $('.filter-noitem-message'),
      $filterTags = $('.filter-tags'),
      $filterTagsLabel = $filterTags.find('.label'),
      $filterTagsReset = $filterTags.find('.tag-reset'),
      selectedClasses = [];

  $selectFilter.on('change', function () {
    var $this = $(this),
        id = $this.attr('id'),
        value = $this.val(),
        text = $this.find("option:selected").text(),
        checkValue = id + '-' + value;

    let regEx = new RegExp('^' + id + '-', 'ig');

    selectedClasses.slice(0).forEach(function (item, index) {
      let match = item.match(new RegExp('^' + id + '-', 'ig'));

      if (match) {
        selectedClasses.splice(selectedClasses.indexOf(item), 1);
      }
    });

    if (value.length > 0) {
      selectedClasses.push(checkValue);

      var $tag = $('<span class="tag tag-item tag-' + id + '" data-select-id="' + id + '">' + text + '<i class="tag-icon tag-close icon-cross2"></i></span>');
      var tagId = '.tag-' + escapeSelector(id);

      $(tagId).remove();

      $tag.find('.tag-icon').click(function(event) {
        var $this = $(this),
            $parent = $this.parent(),
            id = $parent.attr('data-select-id');

        $parent.remove();
        resetSelect(id);
      });
      $tag.insertBefore( $filterTagsReset );

      $filterTags.find('.label').removeClass('d-none');
      $this.addClass('selected');
    } else {
      $filterTags.find('.label').addClass('d-none');
      $this.removeClass('selected');
    }

    filterItems();
  });

  $inputFilter.keyup(function () {
    var $this = $(this),
        value = $this.val();

    filterItems(value);
  });

  $btnResetFilter.click(function (event) {
    resetAll();
  });
  $filterTagsReset.click(function (event) {
    resetAll();
  });

  filterItems();
}

function escapeSelector(selector) {
  return selector.replace(/%/g, '\\%');
}

function resetSelect(id) {
  if (!id.length) {
    return;
  }

  var $select = $('#' + escapeSelector(id));
  $select.val('').trigger('change');

}

function resetAll() {
  $filterForm.trigger("reset");
  selectedClasses = [];
  $('.tag-item').remove();
  $selectFilter.trigger('change');
  filterItems();
}

function filterItems(searchWord) {

  $filterItems.each(function (item, index) {
    var $this = $(this),
        show = true;

    selectedClasses.forEach(function (item, index) {
      if (!$this.hasClass(item)) {
        show = false;
      }
    });

    if (show
        && typeof searchWord !== 'undefined'
        && !$this.text().toLowerCase().includes(searchWord.toLowerCase())) {
      show = false;
    }

    if (show) {
      showItem($this);
    } else {
      hideItem($this);
    }

  });

  if ($('.filter-item.fadeout').length === filterItemslength) {
    $alertNoItems.removeClass('d-none');
  } else {
    $alertNoItems.addClass('d-none');
  }

};

function showItem($item) {
  if (typeof $item === 'undefined')
    return;

  $item.show()
      .removeClass('fadeout');

};

function hideItem($item) {
  if (typeof $item === 'undefined')
    return;

  $item.addClass('fadeout').hide();
};
